
import { Component, Vue, Emit } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";
import AreaFinder from "@/components/AreaFinder.vue";
import { validationMixin } from "vuelidate";
import { required, requiredIf, minLength } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import { UserPermissions } from "../store/types";
import AreaTreePicker from "@/components/form/AreaTreePicker.vue";
import { AreaNode } from "@/types/groups/AreaNode";

const Eventqueue = namespace("eventqueue");

@Component({
	components: {
		multiselect: Multiselect,
		"area-finder": AreaFinder,
		"area-tree-picker": AreaTreePicker
	},
	// Validation for the patrol Note.
	mixins: [validationMixin],
	validations: {
		patrolNote: {
			required: requiredIf(function() {
				return this.tourNoteRequired;
			}),
			minLength: minLength(1)
		},
		selectedGroup: {
			required
		}
	}
})
export default class ManualPatrol extends Vue {
	handleError: any = null;

	@Eventqueue.Getter("getManualPatrolShown") manualPatrolShown!: boolean;
	@Eventqueue.Getter("getTourNoteRequired") tourNoteRequired: boolean;

	@Eventqueue.Mutation setManualPatrolShown: any;
	@Eventqueue.Mutation setLastEventHandled: () => void;

	@Eventqueue.Action eventControl: any;

	@Getter("getPermissions") permissions: UserPermissions;

	// boolean to define if tour start call has already been made
	public isStartingTour: boolean = false;
	private patrolNote: string = "";
	private selectedGroup: AreaNode = null;

	public created() {
		this.setManualPatrolShown(false);
	}

	@Emit("submit")
	public async onSubmit() {
		this.$v.$touch();

		if (this.$v.$invalid) {
			return;
		}

		// Start manual Patrol.
		this.startManualPatrol();
	}

	public onClose() {
		this.patrolNote = "";
		this.selectedGroup = null;
		this.setManualPatrolShown(false);
	}

	private async startManualPatrol() {
		this.handleError = null;

		// If we are already processing a tour request, don't retrigger
		if (this.isStartingTour) {
			return;
		}

		// We are processing a tour request
		this.isStartingTour = true;

		// Payload object, to send via the action to the API.
		const eventObject = {
			groupId: this.selectedGroup.id,
			patrolNote: this.patrolNote
		};
		// Call action with payload, gets a returned value.
		const patrolResult = await this.eventControl(eventObject);

		if (patrolResult && patrolResult.eventID != null) {
			this.setLastEventHandled();
			this.setManualPatrolShown(false);
			this.$router.push({
				path: `/site-monitor/${patrolResult.eventID}`
			});
		} else {
			let eventType = "";
			switch (patrolResult.existingEventTypeID) {
				case 1:
					eventType = "alarm";
					break;
				case 2:
					eventType = "tour";
					break;
				case 3:
					eventType = "site check";
					break;
				case 6:
					eventType = "test";
					break;
				default:
					break;
			}

			this.handleError = {
				groupTitle: this.selectedGroup.label,
				eventType: eventType
			};
		}

		// We have finished the request
		this.isStartingTour = false;
	}

	public groupDoubleClicked(group: AreaNode) {
		this.selectedGroup = group;

		this.$v.$touch();

		if (this.$v.$invalid) {
			return;
		}

		this.startManualPatrol();
	}
}
